export default __webpack_public_path__ + "static/ShortTerm-redesign-cf2a35d34ac39728b05c1dddaefa069b.png";